let pendingShowInstructions = false;

function onReload(ev) {
    onReset(ev);
    clearUuid();
    pendingShowInstructions = false;
    showUploadInput();
}

function imageLoadedDnd(img) {
    replaceInputImage(img);
    imageLoaded(img);
}

function imageLoaded(img) {
    hideMessage();

    if (img) {

        if (isInvalidImage(img, function(error) {showError(error);})) {
            return;
        }

        if (img.type === 'image/heif' || img.type === 'image/heic') {
            showMainSpinner();
            loadHeifImage(img, 
                function(pngFile) {
                    replaceInputImage(pngFile);
                    pendingShowInstructions = true;
                    loadPreviewImage(pngFile);
                    hideMainSpinner();
                },
                function(error) {
                    hideMainSpinner();
                    reportHeifError(window.PM_CONFIG.apiUrl, getUuid(), 'diamond-art', img, error,
                        function(response) { setUuid(response.uuid); },
                        function() {});
                    showError("da.start_error_loading_image");
                }

            );
        }
        else {
            pendingShowInstructions = true;
            loadPreviewImage(img);
        }
    }
    else {
        showError("da.start_invalid_image_format");
    }
}

// Show the upload instructions overlay only after a user-initiated image
// selection has finished rendering into the preview container (not for
// preloaded images restored from an existing uuid).
document.addEventListener('pm:preview-shown', function() {
    if (pendingShowInstructions) {
        pendingShowInstructions = false;
        if (!getUploadInstructionsShown()) {
            showUploadInstructions();
        }
    }
});

function onCloseUploadInstructionsPreview(ev) {
    ev.preventDefault();
    setUploadInstructionsShown();
    hideUploadInstructions();
}

function showUploadInput() {
    let uploadContainer = $('.pm-upload-container');
    uploadContainer.removeClass("pm-invisible");
    $("#input_image").val("");

    hideMainSpinner();
    showCodeDialog('da', true, function() {
        scrollPreviewIntoView();
    });
}

function showPreloadedImage(uuid) {
    showMainSpinner();
    const apiUrl = window.PM_CONFIG.apiUrl + '/preload/' + uuid;
    getPreloadedImage(apiUrl, 
        function(response) {
            loadPreviewImage(response);
            hideMainSpinner();
        },
        function(jqXHR, textStatus, errorThrown) {
            clearUuid();
            if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                showError(jqXHR.responseJSON.error);
            }
            showUploadInput();
        }
    );
}

function onContinue(ev) {
    ev.preventDefault();

    hideMessage();
    showMainSpinner();
    const uuid = getUuid();
    const apiUrl = window.PM_CONFIG.apiUrl + '/upload/' + uuid;
    upLoadImage(apiUrl, 
        function(response) {
            setUuid(response.uuid);
            window.location.href = response.skip ? '/select' : '/style';
        },
        function(jqXHR, textStatus, errorThrown) {
            console.log(textStatus + '-' + errorThrown);
            hideMainSpinner();
            if (jqXHR.responseJSON && jqXHR.responseJSON.clear) {
                clearUuid();
                removeCode();
                window.location.href = '/start-diamond-art';
            }
            if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                showError(jqXHR.responseJSON.error);
            }
            else {
                showError("da.start_error_loading_image");
            }
        }
    );
}

window.addEventListener('DOMContentLoaded', function(ev) {       
    ev.preventDefault();

    const uuid = getUuid();
    if (uuid)
    {
        showPreloadedImage(uuid);
    } else {
        showUploadInput();
    }

    scrollPreviewIntoView();
    requestAnimationFrame(fitPreviewContainerToScreen);
});
